module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-modern-2-9a4d97c5af10a0ce0c91cb20b42080d6.webp";